import {useMutation} from '@tanstack/react-query';
import {useTrans} from '@ui/i18n/use-trans';
import {toast} from '@ui/toast/toast';
import {message} from '@ui/i18n/message';
import {UseFormReturn} from 'react-hook-form';
import {BackendResponse} from "@common/http/backend-response/backend-response";
import { useNavigate } from 'react-router';
import {onFormQueryError} from "@common/errors/on-form-query-error";
import {apiClient} from "@common/http/query-client";

interface Response extends BackendResponse {}

export interface UnsubscribePagePayload {
    phone: string;
}

export function useSubmitUnsubscribeForm(
    form: UseFormReturn<UnsubscribePagePayload>,
    {
        onDeactivationTime,
    }: { onDeactivationTime?: (date: string) => void } = {}
) {
    const {trans} = useTrans();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: (props: UnsubscribePagePayload) => submitUnsubscribeForm(props),
        onSuccess: (data) => {
            console.log(data);
                if ('success' in data) {
                    toast(trans(message('You have successfully unsubscribed.')));
                } else if ('error' in data) {
                    toast.danger(trans(message('Subscription not found.')));
                }

            if ('deactivation_datetime' in data && typeof data.deactivation_datetime === 'string') {
                if (onDeactivationTime) {
                    onDeactivationTime(data.deactivation_datetime);
                }
            }
        },
        onError: err => onFormQueryError(err, form),
    });
}

function submitUnsubscribeForm(payload: UnsubscribePagePayload): Promise<Response> {
    return apiClient.post('unsubscribe', payload).then(r => r.data);
}
